<template>
  <div class="category-management">
    <div class="filter-container">
      <el-input
          v-model="listQuery.keyword"
          placeholder="分类名称"
          style="width: 200px;"
          class="filter-item"
          @keyup.enter.native="handleFilter"
      />
      <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter"
      >
        搜索
      </el-button>
      <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-plus"
          @click="handleCreate"
      >
        添加分类
      </el-button>
      <el-button
          class="filter-item"
          type="success"
          icon="el-icon-upload2"
          @click="showImportDialog = true"
      >
        导入
      </el-button>
      <el-button
          class="filter-item"
          type="warning"
          icon="el-icon-download"
          @click="handleExport"
      >
        导出
      </el-button>
    </div>

    <el-table
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%;"
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    >
      <el-table-column label="分类ID" prop="id" width="80" align="center" />
      <el-table-column label="分类名称" prop="name" min-width="150" />
      <el-table-column label="分类图标" prop="icon" width="100" align="center">
        <template slot-scope="{row}">
          <i v-if="row.icon" :class="row.icon" style="font-size: 20px;"></i>
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="sort" width="80" align="center" />
      <el-table-column label="状态" prop="status" width="100" align="center">
        <template slot-scope="{row}">
          <el-tag :type="row.status | statusFilter">
            {{ row.status ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createTime" width="160" align="center" />
      <el-table-column label="操作" align="center" width="200" class-name="small-padding fixed-width">
        <template slot-scope="{row}">
          <el-button
              type="primary"
              size="mini"
              @click="handleUpdate(row)"
          >
            编辑
          </el-button>
          <el-button
              v-if="row.status"
              size="mini"
              type="danger"
              @click="handleModifyStatus(row, false)"
          >
            禁用
          </el-button>
          <el-button
              v-else
              size="mini"
              type="success"
              @click="handleModifyStatus(row, true)"
          >
            启用
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
    />


    <!-- 添加/编辑分类对话框 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form
          ref="dataForm"
          :rules="rules"
          :model="temp"
          label-position="left"
          label-width="100px"
          style="width: 400px; margin-left:50px;"
      >
        <el-form-item label="父级分类" prop="parentId">
          <el-cascader
              v-model="temp.parentId"
              :options="categoryOptions"
              :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'children' }"
              clearable
              style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="temp.name" />
        </el-form-item>
        <el-form-item label="分类图标" prop="icon">
          <el-select v-model="temp.icon" placeholder="请选择图标" clearable>
            <el-option
                v-for="item in iconOptions"
                :key="item"
                :label="item"
                :value="item"
            >
              <i :class="item" style="margin-right: 10px;"></i>
              <span>{{ item }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="temp.sort" :min="0" :max="999" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch
              v-model="temp.status"
              active-text="启用"
              inactive-text="禁用"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">
          确认
        </el-button>
      </div>
    </el-dialog>

    <!-- 导入对话框 -->
    <el-dialog title="导入分类" :visible.sync="showImportDialog" width="500px">
      <el-upload
          class="upload-demo"
          drag
          action=""
          :auto-upload="false"
          :on-change="handleImportChange"
          :show-file-list="false"
          accept=".xlsx, .xls"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">请上传 Excel 文件</div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showImportDialog = false">取消</el-button>
        <el-button type="primary" @click="handleImport">确认导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // 分页组件

// 模拟数据
const mockData = [
  {
    id: 1,
    parentId: 0,
    name: '电子产品',
    icon: 'el-icon-mobile-phone',
    sort: 1,
    status: true,
    createTime: '2023-01-01 10:00:00',
    children: [
      {
        id: 11,
        parentId: 1,
        name: '手机',
        icon: 'el-icon-phone',
        sort: 1,
        status: true,
        createTime: '2023-01-01 10:10:00'
      },
      {
        id: 12,
        parentId: 1,
        name: '电脑',
        icon: 'el-icon-laptop',
        sort: 2,
        status: true,
        createTime: '2023-01-01 10:20:00'
      }
    ]
  },
  {
    id: 2,
    parentId: 0,
    name: '服装',
    icon: 'el-icon-account',
    sort: 2,
    status: true,
    createTime: '2023-01-02 10:00:00',
    children: [
      {
        id: 21,
        parentId: 2,
        name: '男装',
        icon: 'el-icon-male',
        sort: 1,
        status: true,
        createTime: '2023-01-02 10:10:00'
      },
      {
        id: 22,
        parentId: 2,
        name: '女装',
        icon: 'el-icon-female',
        sort: 2,
        status: true,
        createTime: '2023-01-02 10:20:00'
      }
    ]
  },
  {
    id: 3,
    parentId: 0,
    name: '食品',
    icon: 'el-icon-food',
    sort: 3,
    status: true,
    createTime: '2023-01-03 10:00:00'
  }
]

export default {
  name: 'CategoryManagement',
  components: { Pagination },
  filters: {
    statusFilter(status) {
      const statusMap = {
        true: 'success',
        false: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 20,
        keyword: ''
      },
      temp: {
        id: undefined,
        parentId: [],
        name: '',
        icon: '',
        sort: 0,
        status: true
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑分类',
        create: '添加分类'
      },
      rules: {
        name: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }]
      },
      categoryOptions: [],
      iconOptions: [
        'el-icon-mobile-phone',
        'el-icon-phone',
        'el-icon-laptop',
        'el-icon-account',
        'el-icon-male',
        'el-icon-female',
        'el-icon-food',
        'el-icon-ice-cream',
        'el-icon-coffee',
        'el-icon-house',
        'el-icon-shopping-cart-full',
        'el-icon-present'
      ],
      showImportDialog: false,
      importFile: null
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      // 模拟API请求延迟
      setTimeout(() => {
        let filteredList = JSON.parse(JSON.stringify(mockData))

        // 模拟搜索功能
        if (this.listQuery.keyword) {
          filteredList = this.filterByKeyword(filteredList, this.listQuery.keyword)
        }

        this.list = filteredList
        this.total = filteredList.length
        this.listLoading = false

        // 生成分类选项用于级联选择器
        this.generateCategoryOptions()
      }, 500)
    },
    filterByKeyword(list, keyword) {
      const result = []
      const lowerKeyword = keyword.toLowerCase()

      list.forEach(item => {
        const match = item.name.toLowerCase().includes(lowerKeyword)
        if (match) {
          result.push(item)
        } else if (item.children && item.children.length) {
          const filteredChildren = this.filterByKeyword(item.children, keyword)
          if (filteredChildren.length) {
            const newItem = { ...item, children: filteredChildren }
            result.push(newItem)
          }
        }
      })

      return result
    },
    generateCategoryOptions() {
      const options = JSON.parse(JSON.stringify(mockData))
      // 添加一个"无"选项
      options.unshift({
        id: 0,
        name: '无(一级分类)',
        children: []
      })
      this.categoryOptions = options
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        parentId: [],
        name: '',
        icon: '',
        sort: 0,
        status: true
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          // 模拟创建操作
          const newId = Math.max(...mockData.map(item => item.id)) + 1
          const parentId = this.temp.parentId.length ? this.temp.parentId[this.temp.parentId.length - 1] : 0

          const newCategory = {
            id: newId,
            parentId: parentId,
            name: this.temp.name,
            icon: this.temp.icon,
            sort: this.temp.sort,
            status: this.temp.status,
            createTime: new Date().toLocaleString()
          }

          // 添加到模拟数据中
          if (parentId === 0) {
            mockData.push(newCategory)
          } else {
            const parent = this.findCategory(mockData, parentId)
            if (parent) {
              if (!parent.children) {
                parent.children = []
              }
              parent.children.push(newCategory)
            }
          }

          this.dialogFormVisible = false
          this.$message.success('添加成功')
          this.getList()
        }
      })
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row) // 复制对象
      this.temp.parentId = this.getParentIds(row.parentId)
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          // 模拟更新操作
          const parentId = this.temp.parentId.length ? this.temp.parentId[this.temp.parentId.length - 1] : 0
          const oldParentId = this.temp.parentId

          const category = this.findCategory(mockData, this.temp.id)
          if (category) {
            // 如果父级分类有变化
            if (parentId !== oldParentId) {
              // 从原父级删除
              this.removeFromParent(mockData, this.temp.id)

              // 添加到新父级
              if (parentId === 0) {
                mockData.push(category)
              } else {
                const newParent = this.findCategory(mockData, parentId)
                if (newParent) {
                  if (!newParent.children) {
                    newParent.children = []
                  }
                  newParent.children.push(category)
                }
              }
            }

            // 更新分类信息
            Object.assign(category, {
              parentId: parentId,
              name: this.temp.name,
              icon: this.temp.icon,
              sort: this.temp.sort,
              status: this.temp.status
            })
          }

          this.dialogFormVisible = false
          this.$message.success('更新成功')
          this.getList()
        }
      })
    },
    handleModifyStatus(row, status) {
      // 模拟状态修改
      const category = this.findCategory(mockData, row.id)
      if (category) {
        category.status = status
        this.$message.success(status ? '已启用' : '已禁用')
        this.getList()
      }
    },
    findCategory(list, id) {
      for (const item of list) {
        if (item.id === id) {
          return item
        }
        if (item.children && item.children.length) {
          const found = this.findCategory(item.children, id)
          if (found) return found
        }
      }
      return null
    },
    removeFromParent(list, id) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].id === id) {
          list.splice(i, 1)
          return true
        }
        if (list[i].children && list[i].children.length) {
          if (this.removeFromParent(list[i].children, id)) {
            return true
          }
        }
      }
      return false
    },
    getParentIds(parentId) {
      if (parentId === 0) return []

      const parent = this.findCategory(mockData, parentId)
      if (!parent) return []

      const ids = []
      let current = parent
      while (current && current.parentId !== 0) {
        ids.unshift(current.parentId)
        current = this.findCategory(mockData, current.parentId)
      }
      ids.push(parentId)
      return ids
    },
    handleImportChange(file) {
      this.importFile = file
    },
    handleImport() {
      if (!this.importFile) {
        this.$message.warning('请先选择文件')
        return
      }

      // 模拟导入操作
      this.$message.success('导入成功(模拟)')
      this.showImportDialog = false
      this.getList()
    },
    handleExport() {
      // 模拟导出操作
      const data = JSON.stringify(this.list, null, 2)
      const blob = new Blob([data], { type: 'text/plain' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `商品分类_${new Date().toLocaleDateString()}.json`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      this.$message.success('导出成功')
    }
  }
}
</script>

<style scoped>
.category-management {
  padding: 20px;
}

.filter-container {
  margin-bottom: 20px;
}

.filter-item {
  margin-right: 10px;
}

.upload-demo {
  text-align: center;
}

.el-upload__tip {
  margin-top: 10px;
  color: #606266;
  font-size: 14px;
}
</style>